export default __webpack_public_path__ + "static/s5-5d4dd6c1cad0c8a9052ab998e30cb3b3.webp";